import React from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { window } from 'browser-monads';

import { useAuth } from '@providers/auth-provider';

import './Subscribe.less';
import styles from './Subscribe.module.less';

const { location } = window;

const Subscribe = () => {
  const { loginWithRedirect } = useAuth();
  const login = () =>
    loginWithRedirect({
      appState: {
        path: location.pathname,
      },
    });

  return (
    <div className={classNames(styles.subscribe, styles.typography)}>
      <a href="https://www.2harvest.org/">
        <img
          src="/2ndharvest-logo.png"
          alt="Second Harvest Heartland"
          className={styles.partner}
        />
      </a>
      <h3 className={styles.message}>
        1 in 8 Americans struggles with food insecurity.
      </h3>
      <p className={styles.prompt}>
        Sign up for{' '}
        <a href="https://www.livemenu.io" target="_blank">
          LiveMenu
        </a>{' '}
        to enable enhanced features and get menu updates. Your signup will
        provide <span className={styles.highlight}>1 meal</span> to those in
        need through{' '}
        <a href="https://www.2harvest.org/">Second Harvest Heartland</a>.
      </p>
      <Button type="primary" size="large" block onClick={login}>
        Help Feed the Hungry
      </Button>
    </div>
  );
};

export default Subscribe;
